import { render, staticRenderFns } from "./DescriptionInput.vue?vue&type=template&id=1fec7fa3&"
import script from "./DescriptionInput.vue?vue&type=script&lang=ts&"
export * from "./DescriptionInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports